// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type AppsManifestValidateResponse = SlackAPIResponse & {
  error?: string;
  errors?: Error[];
  needed?: string;
  ok: boolean;
  provided?: string;
  response_metadata?: ResponseMetadata;
};

export interface Error {
  code?: string;
  message?: string;
  pointer?: string;
  related_component?: string;
}

export interface ResponseMetadata {
  messages?: string[];
}
